import React from "react";
import { Box, Typography } from "@mui/material";
import { useLang } from "../../Contexts/LanguageContext";

export default function WelcomeScreen() {
  const { t, isRTL } = useLang();
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        src="/enmaeya-logo.png"
        alt="Logo"
        sx={{ width: 80, height: 80, mb: 2 }}
      />
      <Typography variant="h5" fontWeight="bold" style={{ color: "#00314f", fontFamily: isRTL ? "'Noto Kufi Arabic', sans-serif" : 'inherit' }}>
        {t.welcomeTitle}
      </Typography>
      <Typography variant="body1" style={{ color: "#00314f", fontFamily: isRTL ? "'Noto Kufi Arabic', sans-serif" : 'inherit' }} maxWidth="500px" mt={1}>
        {t.welcomeSub}
      </Typography>
    </Box>
  );
}
